import {
    Component,
    OnInit,
    ViewChild,
    AfterViewInit
} from '@angular/core';
import { PartInfo } from 'src/app/models/partinfo';
import { ProposalService } from 'src/app/services/proposal.service';
import { of } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';
import { PendingProposalPartInfo } from 'src/app/models/internal/pendingproposalpartinfo';
import { SearchFilter } from 'src/app/models/internal/searchfilter';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { Constants } from 'src/app/core/constants';
import { QueryPartInfoSearchByPartNumberDTO } from 'src/app/models/internal/query-partInfo-searchby-partnumber-dto';
import { QueryExemptedPendingProposalDTO } from 'src/app/models/internal/query-exemptedpendingproposal-dto';
import { BaseGridPage } from 'src/app/core/basepages/allbasepages';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { CopyProposalDTO } from 'src/app/models/internal/copy-proposal-dto';
import { CopyFromProposalDTO } from 'src/app/models/internal/copyfrom-proposal-dto';
import { CopyfromProposalListComponent } from 'src/app/proposal/lists/copyfrom-proposal-list/copyfrom-proposal-list.component';
import { SearchFilter_PendingProposals } from 'src/app/models/filters/searchfilter-pendingproposals';
import { PartBasicInfo } from 'src/app/models/partbasicinfo';
import {SourceType} from 'src/app/models/sourcetype';
import { PartSystemDTO } from 'src/app/models/external/partsystem-dto';
import UIHelper from 'src/app/core/utility/ui-helper';
import * as moment from 'moment';
import Helper from 'src/app/core/utility/helper';
import { NGXLogger } from 'ngx-logger';
import { environment } from 'src/environments/environment';
import { AppSettings } from 'src/app/app.settings';
import { TeslaAutocompleteComponent } from '@tesla/angular2-tesla-common/autocomplete/autocomplete.component';
import { ExemptedPartDTO } from 'src/app/models/internal/exemptedpart-dto';
import { ICanExportData } from 'src/app/core/interfaces/can-export-data.interface';
import { ComponentCanDeactivate } from '../../../core/interfaces/component-can-deactive.interface';
import { MatDialog } from '@angular/material/dialog';
import { PeExemptpartReasonComponent } from 'src/app/commonUI/pe-exemptpart-reason/pe-exemptpart-reason.component';

@Component({
    selector: 'app-exemptedparts-list',
    templateUrl: './exemptedparts-list.component.html',
    styleUrls: ['./exemptedparts-list.component.scss'],
})
export class ExemptedPartsListComponent extends BaseGridPage implements OnInit, AfterViewInit, ICanExportData, ComponentCanDeactivate {
    excelFilenamePrefix = "ExemptedPartsList_";
    pageSizes: number[] = [10, 25, 50];
    searchFilter_PendingProposals: SearchFilter_PendingProposals = new SearchFilter_PendingProposals();
    filterForm: FormGroup;
    partList: PartBasicInfo[];
    pendingProposalsForm: FormGroup;
    showBase7proposalsMessageFound = false;
    showBase7proposalsMessageNotFound = false;
    base7proposalsFoundMessage: string;
    base7proposalsNotFoundMessage: string;
    POUoM: string;
    supplierCode: string;
    exemptedPendingProposalList: ExemptedPartDTO[];
    partInfoIds: number[];
    sourceProposalsToCopyFromList: any[];
    partProposalInfoToBeCreatedList: PendingProposalPartInfo[];
    sourceTypeList: SourceType[];
    partSystemList: PartSystemDTO[];
    isInboundShipment: boolean = true;
    allItemsCheckBoxSelected: boolean = false;
    locStorage = Constants.localStorageKeys;
    targetPartInfoIdList: PendingProposalPartInfo[] = [];
    showCopyFromComponent = false;
    searchSupplierURL: string ;
    autoCompletePEURL: string ;
    isExemptedSelectMenu = [{text: 'True', value: true}, {text: 'False', value: false}];
    exemptPartsEdited: boolean = false;
    updateExemptSubmitClicked: boolean = false;
    OpenExemptionReasonDialog: boolean = false;
    @ViewChild(CopyfromProposalListComponent)
    CopyFromProposalListComponent: CopyfromProposalListComponent;
    @ViewChild('PEAutoComplete') PEAutoComplete: TeslaAutocompleteComponent;
    @ViewChild('SupplierAutoComplete') SupplierAutoComplete: TeslaAutocompleteComponent;

    public formErrors = {
        itemsSelected: '',
        SourceTypeId: '',
        PartNumber: '',
        EngineerUserId: '',
        HotRequestFlag: '',
        PartCategoryId: '',
        SupplierCode: '',
        IsExempted: '',
    };

    constructor(
        private dataService: DataService,
        private fb: FormBuilder,
        private proposalService: ProposalService,
        localstorageService: LocalstorageService,
        private toastService: ToastService,
        private formService: FormService,
        private router: Router,
        appSettings: AppSettings,
        logger: NGXLogger,
        private matDialog: MatDialog
    ) {
        super(localstorageService, logger, appSettings);
        this.pendingProposalsForm = this.fb.group({
            itemsSelected: [null]
        });
        this.filterForm = this.fb.group({
            SourceTypeId: [null],
            PartNumber: [null],
            EngineerUserId: [null],
            HotRequestFlag: [null],
            PartCategoryId: [null],
            SupplierCode: [null],
            IsExempted: [null],
        });        
        this.searchSupplierURL = this.appSettings.Packaging2APIUrl + '/externaldata/supplier/all';
        this.autoCompletePEURL = this.appSettings.Packaging2APIUrl + '/peassignment/pe/all';
    }

    ngOnInit() {
        this.exemptedPendingProposalList = [];
        this.exemptPartsEdited = false;
        this.updateExemptSubmitClicked = false;
        this.initFilterValues();
        this.getSourceTypes();
        this.getPartSystems();
        this.fillGrid();
    }

    fillGrid(): void {
        this.logger.debug("In fillGrid");
        this.sourceProposalsToCopyFromList = [];
        this.filter.Skip = this.skip;
        this.filter.Take = this.pageSize;
        this.allItemsCheckBoxSelected = false;
        const queryExemptedPendingProposalDTO: QueryExemptedPendingProposalDTO = {
            SearchFilter: this.filter,
            HotRequest: this.filterForm.get('HotRequestFlag').value,
            SupplierCode: this.filterForm.get('SupplierCode').value,
        };
        this.supplierCode = queryExemptedPendingProposalDTO.SupplierCode;
        this.getPartsForSupplierForExemption(queryExemptedPendingProposalDTO);
    }

    initFilterValues(): void {
        this.filter = new SearchFilter();
    }

    getPartsForSupplierForExemption(queryExemptedPendingProposalDTO: QueryExemptedPendingProposalDTO) {
        this.UpdateFilter();
        //TMS-31217 Enter SupplierCode or PartNumber for Exempt part search
        if (this.filterForm.get('SupplierCode').value !== null || this.filterForm.get('PartNumber').value !== null) {
            this.supplierCode = this.filterForm.get('SupplierCode').value;
            queryExemptedPendingProposalDTO.SearchFilter = this.filter;
            if (this.filterForm.get('IsExempted').value == true) {
                this.dataService
                    .getallexemptedParts(queryExemptedPendingProposalDTO)
                    .subscribe((response: any) => {
                        if (response != null) {
                            this.exemptedPendingProposalList = response.Data;
                            this.gridView = of({
                                data: response.Data,
                                total: response.Total ? response.Total : 0,
                            });
                        }
                    });
            }
            else {
                this.dataService
                .getPartsForSupplierForExemption(queryExemptedPendingProposalDTO)
                .subscribe((response: any) => {
                    if (response != null) {
                        this.exemptedPendingProposalList = response.Data;
                        this.gridView = of({
                            data: response.Data,
                            total: response.Total ? response.Total : 0,
                        });
                    }
                });
            }

        }
    }

    UpdateFilter() {
        this.filter.SearchFilterConditions = [];
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'SupplierCode', Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'PartNumber', Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_LIKE);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'SourceTypeId', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'EngineerUserId', Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, 'IsExempted', Constants.FILTER_DATATYPE_BOOLEAN,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
    }

    getSourceTypes() {
        this.dataService.getParentSourceTypes().subscribe((response: any) => {
            if (response && response.Data != null) {
                this.sourceTypeList = response.Data;
            }
        });
    }

    getPartSystemName(id: number) {
        if (id != null) {
            return this.partSystemList.find(x => x.Id === id).Description;
        }
        return '';
    }

    getPartSystems() {
        this.dataService.getPartSystems().subscribe((response: any) => {
                if (response != null && response.Success) {
                    this.partSystemList = response.Data;
                    // this.partSystemList = this.excludeAlreadyAssignedPartSystems(this.partSystemList);
                }
            });
    }

    onEmptyPE(eventObj: any): void {
        this.filterForm.controls['EngineerUserId'].patchValue(null);
        this.PEAutoComplete.list = [];
        if (this.filter != null && this.filter.SearchFilterConditions != null && this.filter.SearchFilterConditions.findIndex(x => x.Field === 'EngineerUserId') >= 0) {
            this.filter.SearchFilterConditions.splice(this.filter.SearchFilterConditions.findIndex(x => x.Field === 'EngineerUserId'), 1);
        }
    }

    onEmptySupplierCode(eventObj: any): void {
        this.filterForm.controls['SupplierCode'].patchValue(null);
        this.SupplierAutoComplete.list = [];
        if (this.filter != null && this.filter.SearchFilterConditions != null && this.filter.SearchFilterConditions.findIndex(x => x.Field === 'SupplierCode') >= 0) {
            this.filter.SearchFilterConditions.splice(this.filter.SearchFilterConditions.findIndex(x => x.Field === 'SupplierCode'), 1);
        }
    }

    updateExemptStatus() {
        if (!Array.isArray(this.exemptedPendingProposalList) ||
            !this.exemptedPendingProposalList.length) {
                return;
        }

        //tms-34054 provide exemption reason only when a part needs to be exempted. Do not to give reason for unexempting 'already' exempted part 
        if (this.OpenExemptionReasonDialog == true) {
            //tms-33947 provide exemption reason for the selected parts 
            const dialogRef = this.matDialog.open(PeExemptpartReasonComponent, {
                height: '300px',
                width: '500px',
                data: this.exemptedPendingProposalList
            });

            dialogRef.afterClosed().subscribe(result => {
                this.updateExemptSubmitClicked = true;
                this.fillGrid();
            });
        }
        else {
            this.dataService
            .updateExemptedPart(this.exemptedPendingProposalList)
            .subscribe((response: any) => {
                        if (response != null && response.Success) {
                            this.toastService.success('Part exemption updated successfully');
                            this.updateExemptSubmitClicked = true;
                            this.fillGrid();
                        } else {
                            this.toastService.error(
                                'Could not update exemption for the part'
                            );
                        }
            });

        }

    }

    clearFilter() {
        this.filterForm.reset();
        this.filter.SearchFilterConditions = [];
        this.search();
        this.supplierCode = null;
        // var checkbox = document.getElementById("chkHotRequestFlag");
        // checkbox.indeterminate = true;
        // window.location.reload();
    }

    ValidateForm() {
        Helper.resetFormErrors(this.formErrors);

        this.formErrors = this.formService.validateForm(
            <FormGroup>this.filterForm,
            this.formErrors
        );
        if (this.filterForm.get('SupplierCode').value === null && this.filterForm.get('PartNumber').value === null) {
            this.toastService.error(
                'Please select Supplier Code or PartNumber for Exempt Part search'
            );
        }
    }

    getSourceType(dataItem) {
        if (dataItem.ParentSourceTypeId) {
            const source = this.sourceTypeList.find(x => x.Id == dataItem.ParentSourceTypeId);
            return UIHelper.supplierDisplayCell(source.Name, source.Description);
        } else {
            return UIHelper.supplierDisplayCell(dataItem.SourceTypeName, dataItem.SourceTypeDescription);
        }
    }

    navigateToSavedProposals() {
        this.router.navigate(['/saved-proposals'] );
        // window.location.href = '/saved-proposals/';

    }

    getExemptParts() {
        this.ValidateForm();
        this.UpdateFilter();
        this.search();
    }

    exportData() {
        const filename = this.excelFilenamePrefix + Helper.formatDateTime(new Date()) + '.xlsx';

        const queryExemptedPendingProposalDTO: QueryExemptedPendingProposalDTO = {
            SearchFilter: this.filter,
            SupplierCode: this.supplierCode,
            HotRequest: null,
        };

        if (this.filterForm.get('IsExempted').value == true) {
            this.dataService
                .getallexemptedPartsExcel(queryExemptedPendingProposalDTO)
                .subscribe((response: any) => {
                    if (response != null && response.Success) {
                        UIHelper.DownloadExcelFile(response.Data, filename);
                    } else {
                        this.toastService.error(
                            'Could not export data'
                        );
                    }
                });
        }
        else {
            this.dataService
            .getPartsForSupplierForExemptionExcel(queryExemptedPendingProposalDTO)
            .subscribe((response: any) => {
                if (response != null && response.Success) {
                    UIHelper.DownloadExcelFile(response.Data, filename);
                } else {
                    this.toastService.error (
                        'Could not export data'
                    );
                }
            });
        }
    }

    /*   onRowSelectedChange() {
           this.exemptPartsEdited = true;
       } */

    onRowSelectedChange(event: any) {
        if (event.IsExempted == true) {
            this.OpenExemptionReasonDialog = true;
        }
        else {
            this.OpenExemptionReasonDialog = false;
        }
        this.exemptPartsEdited = true;
    }

    canDeactivate(): boolean {
        return ( !this.exemptPartsEdited ||
                this.updateExemptSubmitClicked );
    }

    // Revert Based On TMS-5526
    // getExpiresIn(data: PendingProposalPartInfo) {
    //     const remainder = (moment(data.CreatedOn).diff(moment.utc(), 'days')) + 7;
    //     return remainder === 0 ? 'Expiring today' : 'Expires in ' + (remainder) + ' days';
    // }
}
